module.exports = __webpack_public_path__ + "static/media/DeleteMyInfo.107292a3.png";